export function getPartBucket(proj, partNum) {
  const rows = Object.values(proj.pipeline || {}).filter(r => r.part_number === partNum);
  if (!rows.length) return "pending";
  if (rows.every(r => r.status === "done" || r.status === "skipped")) return "complete";
  if (rows.some(r => r.status === "active")) return "active";
  const partStageRows = rows.filter(r => r.part_number > 0);
  if (partStageRows.length && partStageRows.every(r => r.status === "done" || r.status === "skipped")) return "review";
  return "pending";
}
